import { Tabs, Text } from '@mantine/core';
import { SideBarWrapper, SideBarContent, TabsListHeader } from './styles';
import { LuIterationCw } from 'react-icons/lu';
import { PiBracketsCurlyBold } from 'react-icons/pi';
import { EnvironmentPanel, IteratorPanel, Header } from '../../molecules';
import { useEffect } from 'react';
import { useStore } from '@/store';
import { useNavigate } from 'react-router';
import { useEntryContext } from '../../context';

export const ConfigureView = () => {
  const name = useEntryContext((s) => s.getName()) as string;
  const [setHeader, clearHeader, configureViewTab, setConfigureViewTab] =
    useStore(({ ui }) => [
      ui.setHeader,
      ui.clearHeader,
      ui.configureViewTab,
      ui.setConfigureViewTab,
    ]);
  const navigate = useNavigate();

  useEffect(() => {
    const title = `Configure ${name.charAt(0).toUpperCase() + name.slice(1)} Context`;
    setHeader({ title, back: () => navigate('../..') });
    return () => clearHeader();
  }, [name, setHeader, clearHeader, navigate]);
  return (
    <SideBarWrapper>
      <Header />
      <Tabs
        h={'100%'}
        value={configureViewTab}
        onTabChange={(value) => {
          if (value) setConfigureViewTab(value);
        }}
      >
        <TabsListHeader grow>
          <Tabs.Tab value="env-variables" icon={<PiBracketsCurlyBold />}>
            <Text>Environment Variables</Text>
          </Tabs.Tab>
          <Tabs.Tab value="iterators" icon={<LuIterationCw />}>
            <Text>Iterators</Text>
          </Tabs.Tab>
        </TabsListHeader>

        <SideBarContent>
          <Tabs.Panel h={'85%'} value="env-variables" pt="xs">
            <EnvironmentPanel />
          </Tabs.Panel>
          <Tabs.Panel h={'85%'} value="iterators" pt="xs">
            <IteratorPanel />
          </Tabs.Panel>
        </SideBarContent>
      </Tabs>
    </SideBarWrapper>
  );
};
